import { getWindow } from '@jira/ssr__browser-globals/src/getWindow.tsx';
import { bootstrapWrmClient } from '../bootstrapWrmClient.tsx';
import Deferred from '../deferred.tsx';

let heritageIsLoaded = false;
/**
 * @returns if WMR heritage is loaded
 */
export const isWRMHeritageLoaded = (): boolean => heritageIsLoaded;
/**
 * Awaiting this promise will ensure heritage remainder has already been loaded.
 */
export const waitForHeritage = (): null | Deferred<void> | Promise<void> => {
	if (__SERVER__) {
		// WRM is not used on server
		// return null because we don't want to ?.then() chain into loadBridge functions
		return null;
	}
	if (!__SPA__) {
		// Heritage remainder is an SPA concept
		// return promise because we want to ?.then() chain into loadBridge functions
		return Promise.resolve();
	}

	const browserWindow = getWindow();
	if (!browserWindow) {
		return null;
	}
	if (!browserWindow.__WAIT_FOR_HERITAGE__) {
		heritageIsLoaded = false;
		const heritageDeferred = new Deferred<void>();
		browserWindow.__WAIT_FOR_HERITAGE__ = heritageDeferred;

		bootstrapWrmClient().then(() => {
			heritageIsLoaded = true;
			heritageDeferred.resolve();
		});
	}

	return browserWindow.__WAIT_FOR_HERITAGE__;
};
